"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlacementToJSON = exports.PlacementFromJSONTyped = exports.PlacementFromJSON = exports.Placement = void 0;
/**
 * Placement of the ad.
 * @export
 */
exports.Placement = {
    Browse: 'BROWSE',
    Music: 'MUSIC',
    Podcast: 'PODCAST',
    Homepage: 'HOMEPAGE',
    FormatsTest: 'FORMATS_TEST',
    Marquee: 'MARQUEE',
    NativeAdsHomeShelf: 'NATIVE_ADS_HOME_SHELF',
    PodcastSai: 'PODCAST_SAI',
    PodcastDai: 'PODCAST_DAI'
};
function PlacementFromJSON(json) {
    return PlacementFromJSONTyped(json, false);
}
exports.PlacementFromJSON = PlacementFromJSON;
function PlacementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.PlacementFromJSONTyped = PlacementFromJSONTyped;
function PlacementToJSON(value) {
    return value;
}
exports.PlacementToJSON = PlacementToJSON;
